import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {FlexiEditButton} from '@flexinet/ui-components';

import {EditFormDrawer} from '../drawers/EditFormDrawer';
import {Product} from '../types';

export const EditRecordButton = ({record}: { record: Product }) => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <FlexiEditButton onClick={() => setOpened(true)}>
                {I18n.get('Edit')}
            </FlexiEditButton>
            {opened && <EditFormDrawer record={record} opened={opened} onClose={() => setOpened(false)}/>}
        </>
    );
};
